import { PICTURES } from "../actions/pictures";

const itemsPerPage = 12;
const defaultState = {
  trainings: {}, // [id]: { page: 1, itemsPerPage: 12, list: [], count: 0 }
  lessons: {},
  all: {},
};

export default (state = defaultState, { type, entity, id, ...action }) => {
  const anotherEntity = entity === "trainings" ? "lessons" : "trainings";
  switch (type) {
    case PICTURES.LOAD:
      return entity === "all"
        ? {
          ...state,
          [entity]: {
            ...state[entity],
            all: {
              ...state[entity].all,
              itemsPerPage,
              isLoaded: false,
              list: [],
            },
          },
          lessons: {},
          trainings: {},
        }
        : {
          ...state,
          [entity]: {
            ...state[entity],
            [id]: {
              ...state[entity][id],
              itemsPerPage,
              isLoaded: false,
              list: [],
            },
          },
          [anotherEntity]: {},
          all: {},
        };

    case PICTURES.LOAD_DONE:
      return entity === "all"
        ? {
          ...state,
          [entity]: {
            ...state[entity],
            all: {
              ...state[entity].all,
              page: action.page,
              list: action.records,
              count: action.count,
              isLoaded: true,
            },
          },
        }
        : {
          ...state,
          [entity]: {
            ...state[entity],
            [id]: {
              ...state[entity][id],
              page: action.page,
              list: action.records,
              count: action.count,
              isLoaded: true,
            },
          },
        };

    case PICTURES.LOAD_FAILED:
      console.log(action.message);
      return {
        ...state,
        [entity]: { ...state[entity], [id]: { isLoaded: true } },
      };

    case PICTURES.UPLOAD_DONE:
      return {
        ...state,
        [entity]: {
          ...state[entity],
          [id]: {
            ...state[entity][id],
            file_link: action.file_link,
            storage_id: action.storage_id,
            original_name: action.original_name,
            size: action.size,
            duration: action.duration,
          },
        },
      };

    case PICTURES.REMOVE_UPLOADED_DONE:
      return {
        ...state,
        [entity]: {
          ...state[entity],
          [id]: {
            ...state[entity][id],
            file_link: null,
            storage_id: null,
            original_name: null,
            size: null,
            duration: null,
          },
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/pictures.js